module.exports = __webpack_public_path__ + "img/thumbnail_Nilgai_m_normal.43b488e6.png";